// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__gi5id","empty":"ModalGraph_empty__1bi4g"};